import React, { useState, useEffect, useRef } from 'react'
import classes from './AdvancedBiddingScreen.module.css'
import RemainingTime from './RemainingTime'
import Loader from '../../Shared/Loader'
import Axios from '../../../Axios'
import { useAppContext } from '../../../Context/AppContext'
import { useLocation, useHistory } from "react-router-dom";
import { toast } from 'react-toastify'
import { Urls } from '../../../Urls'
import { Activity, currentRequestTimeStamp, numberWithCommas, ActivityAuction, isMobile } from '../../../Constants'
import ReactGA from 'react-ga'
import PopupWidget from '../../PopupWidget'
import mixpanel from 'mixpanel-browser'
import AuctionChat from '../Chat/Chat'
import ReactTooltip from "react-tooltip";
import { auctionDetailsFromDB, checkBlockUnblock, db_time_stamp, getChats, titleCase, updateAuctionStatus, updateL1Quote, updateTransporterStatusInDB, updatedTime } from '../../../Utility'
import { decryptResponse } from '../../RateCard/utils'
import ConfirmDialog from '../../Shared/ConfirmDialog2/ConfirmDialog2'
import { useMixPanelForTracking } from '../../../shared_utilities/trackMixPanel'

const AdvancedBiddingScreen = () => {
    const { transporterInfo,clientIp} = useAppContext();
    const {TrackMixPanel} = useMixPanelForTracking()
    const history = useHistory()
    const location = useLocation()
    const [transporterAccess, setTransporterAccess] = useState(false);
    const [auctionDetails, setauctionDetails] = useState({})
    const [rank, setrank] = useState('')
    const [L1_Quote, setL1_Quote] = useState(0)
    const [bidAmount, setbidAmount] = useState(0)
    const [isFirstRender, setIsFirstRender] = useState(true);
    const [myBid, setmyBid] = useState(0)
    const [TimerDate, setTimerDate] = useState()
    const [show, setShow] = useState(false)
    const [Bid_updated, setBid_updated] = useState()
    const [auctionClosed, setauctionClosed] = useState(false)
    const [reload_timer, setreload_timer] = useState(false)
    const [starttime, setStarttime] = useState()
    const [scroll, setscroll] = useState('')
    const [showScroll, setshowScroll] = useState(false)
    const [showBlocked, setShowBlocked] = useState(false)
    const [auctionpaused, setAuctionpaused] = useState(false)
    const [paused_timestamp, setpaused_timestamp] = useState('')
    const [extensionCount, setextensionCount] = useState(0)
    const [connection_msg_list, setconnection_msg_list] = useState([])
    const [optionList, setOptionList] = useState([{
        "option_desc": "",
        "option_bid_decrement": 0,
        "option_opening_bid": 0,
        "option_bid_amount": 0,
    }])
    const [bidlist, setbidlist] = useState([])
    const [buttonClassName, setButtonClassName] = useState('bg-colo')
    const [offset, setOffset ] = useState(0) 
    const timeoutRef = useRef(null);
    const firstRunRef = useRef(true);
    const [timerKey, setTimerKey] = useState(0);
    const [isSubmitClicked, setIsSubmitClicked] = useState(false); // Track submit button click
    const [isBidInvalid, setIsBidInvalid] = useState(false);

    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        message: "",
        onConfirm: () => {},
        variant: "default",
        title: "Are you sure?",
        disableButton: auctionClosed || auctionpaused,
    });
    
    const resetConfirmDialog = () => {
        setConfirmDialog({
            isOpen: false,
            message: "",
            onConfirm: () => {},
            variant: "default",
            disableButton: auctionClosed || auctionpaused,
        });
    };

    // const [allFinalOfferSent, setAllFinalOfferSent] = useState(false); // State for button text
    // useEffect hook is executed once when the component mounts.
    useEffect(() => {
        // Fetches auction details from the database and updates the scroll and visibility state.
        if(transporterInfo?.transporter_id!==undefined){
            auctionDetailsFromDB(location.state.auction_id, setscroll, setshowScroll,setTransporterAccess)
        }

        // Checks whether the auction is blocked or unblocked and updates the blocked status.
        checkBlockUnblock(location.state.auction_id , setShowBlocked,transporterInfo?.transporter_id,setTransporterAccess)

        // Retrieves chat messages for the auction and updates the chat message list and button class.
        if(transporterInfo?.transporter_id!==undefined){
            getChats(location.state.auction_id, setconnection_msg_list, setButtonClassName,transporterInfo?.transporter_id,transporterInfo?.transporter_name,setTransporterAccess)
        }


        // updateAuctionStatus(location.state.auction_id, setAuctionpaused, setauctionClosed, getAdvanceAuctionDetails)
        
        // Updates the auction status and handles related state updates such as pausing the auction and reloading the timer.
        updateAuctionStatus(location.state.auction_id,setAuctionpaused, setauctionClosed , setreload_timer, reload_timer, setpaused_timestamp, getAdvanceAuctionDetails, location.state.bucket)
        Activity([
          {
            screen: "Auction Chat",
            module: "Auction Chat",
            user_activity: "Advance Auction transporter Chat screen viewed",
            timestamp: currentRequestTimeStamp(),
          },
        ]);
    }, [transporterInfo])

    useEffect(() => {
        if(isFirstRender){
          updatedTime(location.state.auction_id, setTimerDate);
            let startTime = new Date().getTime();
            db_time_stamp(setOffset, startTime);
            setIsFirstRender(false);
        }else{
          if (auctionClosed === false) {
            const intervalId = setInterval(() => {
              updatedTime(location.state.auction_id, setTimerDate);
              let startTime = new Date().getTime();
              db_time_stamp(setOffset, startTime);
            setTimerKey(timerKey+1)
            }, 20000); // 20 seconds
        
            return () => {
              clearInterval(intervalId);
            };
        }
        }
      }, [auctionpaused, auctionClosed, isFirstRender]);
    const getLiveTransporter = async(id,status) => {
        if((id===undefined || id===null || id==="") || !transporterAccess){
          return;
        }
        const payload = {
          status:status
        }
        try {
          await Axios.post(`${Urls.messages}/live_transporters?auction_id=${location.state.auction_id}`,payload)
        } catch (error) {
          console.log(error)
        }
    };
    
    useEffect(() => {
        let transporter_id = transporterInfo && transporterInfo.transporter_id && transporterInfo.transporter_id;
        let transporter_name = transporterInfo && transporterInfo.transporter_name && transporterInfo.transporter_name
        let uid = transporterInfo && transporterInfo?.user_details && transporterInfo?.user_details?.user_id
        // Update the transporter's status in the database to "enter" when the component mounts.
        if(transporter_id !== undefined && transporterAccess){
            getLiveTransporter(transporter_id,"enter");
            window.addEventListener("unload", ()=>{
                getLiveTransporter(transporter_id,"exit");
            });
        }
        // CheckSpeed()
        const start = new Date();
        getAdvanceAuctionDetails(start)

        ReactGA.pageview('BiddingScreen');
        document.title = 'Auction - Bidding Screen'

        const handleBeforeUnload = (e) => {
              if (transporter_id !== undefined && transporterAccess) {
                getLiveTransporter(transporter_id,"exit");
              }
            };
          
        window.addEventListener("beforeunload", handleBeforeUnload);

        setShow(true)
        
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            if (transporter_id !== undefined && transporterAccess) {
                getLiveTransporter(transporter_id ,"exit");
            }
        }
    }, [transporterInfo,transporterAccess])

    /**
   * Fetches auction details from the server and updates relevant states.
   * @param {Date} start - The start time for measuring request duration.
   * @param {string} bucket - The bucket parameter used in the request URL.
   */
    const getAdvanceAuctionDetails = (start, bucket = null) => {
      Axios.get(
        `${Urls.auction}?auction_id=${location.state.auction_id}&procurement_id=${location.state.procurement_id}`
      )
        .then((response) => {
          // DECRYPT RESPONSE
          const res = { data: decryptResponse(response?.data) };

          // set auction details 
          setauctionDetails(res.data.auctions[0]);
          // set ending time
          endingTime(res.data.auctions[0]);

          // update L1 quote
          updateL1Quote(
            location.state.auction_id,
            setmyBid,
            setL1_Quote,
            setbidAmount,
            res.data.auctions[0].bid_decrement_amount,
            setrank,
            transporterInfo.transporter_id,
            setBid_updated,
            setTimerDate,
            setreload_timer,
            reload_timer,
            myBid,
            true,
          );

          let startTime = new Date().getTime()
        db_time_stamp(setOffset, startTime)
        setreload_timer(!reload_timer)

          // set extension count
          setextensionCount(
            res.data.auctions[0] && res.data.auctions[0].extension_count
              ? res.data.auctions[0].extension_count
              : 0
          );

         // set bid list
          var temp = res.data.auctions[0];
          var bid = temp.bid_list;
          setbidlist(temp.bid_list && temp.bid_list[0] ? temp.bid_list[0] : []);

          if (bid.length > 0) {
            var temp_valid_list = [];
            bid.map((item) => {
              if (item.is_valid === true) {
                temp_valid_list.push(item);
              }
            });
            
            setL1_Quote(
              temp_valid_list.length > 0 ? temp_valid_list[0].bid_amount : 0
            );
            var list = [];
            bid.map((item) => {
              if (item.transporter_id === transporterInfo.transporter_id) {
                list.push(item);
              }
            });

            // set option list for lanes
            if (
              temp_valid_list[0] &&
              temp_valid_list[0].transporter_id ===
                transporterInfo.transporter_id
            ) {
              setOptionList(temp_valid_list[0].option_details);
            } else if (temp_valid_list[1]) {
              setOptionList(temp_valid_list[1].option_details);
            } else {
              setOptionList(
                res.data.auctions[0].option_list.map((option) => {
                  option.option_bid_amount = option.option_opening_bid;
                  return option;
                })
              );
            }
            var valid_list = [];
            list.map((item) => {
              if (item.is_valid === true) {
                valid_list.push(item);
              }
            });

            if (list.length > 0) {
              setBid_updated(list[0].is_valid ? "YES" : "NO");
            }
          } else {
            setOptionList(
              res.data.auctions[0].option_list.map((option) => {
                option.option_bid_amount = option.option_opening_bid;
                return option;
              })
            );
            setBid_updated(null);
          }

          // show slow internet message
          setShow(false);
          const timeTaken = new Date() - start;

          if (timeTaken >= 5000) {
            document.getElementById("internet-message").style.display = "block";
          }
        })
        .catch((err) => {
          console.log(err);
          setShow(false);
        });
    };

    /**
     * Calculates and sets the ending time of the auction based on the provided data.
     * @param {Object} data - The auction data object containing various timestamps and status.
     */
    const endingTime = (data) => {
        if(data.server_timestamp){
            setStarttime(new Date(data.server_timestamp))
        }else{
            setStarttime(Date())
        }
    }

    useEffect(() => {
      let count = 0
      if(optionList && optionList.length > 0){
        optionList.map((item, index) => {
            count += parseInt(item.option_bid_amount * item.option_unit_metric)
        })
      }
      setbidAmount(count)
    }, [optionList]) 

    /**
   * Decreases the current bid amount by the lanes's bid decrement amount.
   */
    const BidDecrement = (e, index) => {
        var temp = [...optionList]
        temp[index].option_bid_amount = temp[index].option_bid_amount - temp[index].option_bid_decrement
        setOptionList(temp)
    }

    /**
     * Updates the bid amount state with lanes increment .
     */
    const BidIncrement = (e, index) => {
        var temp = [...optionList]
        var current_bid = parseInt(temp[index].option_bid_amount) + parseInt(temp[index].option_bid_decrement)
        if(parseInt(current_bid) <= parseInt(temp[index].option_opening_bid)) {
            temp[index].option_bid_amount = current_bid
        }
        setOptionList(temp)
    }

    const handleFinalOffer = (index,auctionDetails) => {
        // Deep clone the option list
        const updatedOptionList = optionList.map((item, i) =>
            i === index ? { ...item, final_rate: true } : { ...item }
        );
        TrackMixPanel({
            Definition:`user has clicked on final offer for lane ${index+1}.`,
            ModuleName:"tpmp auction",
            ScreenName:`auctions - ${auctionDetails?.auction_status} auctions - advance bidding screen`,
            Data:{
                "ProcurementName":auctionDetails?.procurement_name,
                "AuctionId":auctionDetails?.auction_id,
                "AuctionDescription":auctionDetails?.auction_description,
                "BidAmount":auctionDetails?.bid_amount,
                "Type":"advanced"
            }
        })
        setOptionList(updatedOptionList); // Update the option list state
        // Now, call submitHandler and pass true for final_rate and the index
        submitHandler(true, index);
    };

    const validateInputs = (optionList, bidAmount, showBlocked) => {
        if (showBlocked) {
            toast.info("You are blocked!");
            return false;
        }

        if (optionList.some(item => item.option_bid_amount <= 0)) {
            toast.info("Invalid bid amounts!");
            return false;
        }

        if (bidAmount <= 0 || Math.sign(bidAmount) !== 1) {
            toast.info("Please enter a valid bid");
            return false;
        }

        return true;
    };

    // Helper to create payload
    const createPayload = (updatedOptionList) => ({
        user_id: transporterInfo.user_details.user_id,
        auction_id: auctionDetails.auction_id,
        transporter_id: transporterInfo.transporter_id,
        transporter_name: transporterInfo.transporter_name,
        bid_amount: bidAmount,
        text: "",
        timestamp: currentRequestTimeStamp(),
        ip: clientIp,
        option_details: updatedOptionList,
        type: "advanced",
    });


    // Helper for submitting the bid
    const submitBid = async (payload, successMessage, errorMessage) => {
        setShow(true);
        try {
            await Axios.post(`${Urls.messages}/messages`, payload);
            setShow(false);
            toast.success(successMessage);
        } catch (err) {
            setShow(false);
            toast.info(errorMessage);
        }
    };

    // Main handler
    const submitHandler = (isFinalOffer, index = null) => {
        setIsSubmitClicked(true);
    
        // Input validation
        if (!validateInputs(optionList, bidAmount, showBlocked)) return;
    
        // Auction paused check
        if (auctionpaused) {
            toast.info("Auction is paused!");
            return;
        }
    
        // Check for bid validity
        const isL1Zero = L1_Quote === 0;
        const isBidValid = isL1Zero || bidAmount < L1_Quote;
    
        if (!isBidValid) {
            setIsBidInvalid(true); // Set invalid state to true
            toast.info("Bid is invalid!");
            return;
        } else {
            setIsBidInvalid(false); // Reset invalid state if valid
        }
    
        const submitBidWithPayload = () => {
            let updatedOptionList;
    
            if (isFinalOffer && index === null) {
                // "All Final Offer" clicked
                updatedOptionList = optionList.map(item => ({ ...item, final_rate: true }));
            } else if (isFinalOffer && index !== null) {
                // Specific "Final Offer" for one item
                updatedOptionList = optionList.map((item, i) =>
                    i === index ? { ...item, final_rate: true } : { ...item, final_rate: false }
                );
            } else {
                // Generic submit without "All Final Offer"
                updatedOptionList = optionList.map(item => {
                    const { final_rate, ...rest } = item; // Exclude `final_rate` from payload
                    return rest;
                });
            }

            const payload = createPayload(updatedOptionList);
    
            submitBid(
                payload,
                isFinalOffer
                    ? "Final offer submitted successfully!"
                    : "Bid submitted successfully!",
                "Submission unsuccessful. Please try again"
            );
            TrackMixPanel({
                Definition:isFinalOffer
                    ? 'user has clicked on the all final offer button.'
                    : 'user has clicked on the submit bid button.',
                ModuleName:"tpmp auction",
                ScreenName:`auctions - ${auctionDetails?.auction_status} auctions - advance bidding screen`,
                Data:{
                    "ProcurementName":auctionDetails?.procurement_name,
                    "AuctionId":auctionDetails?.auction_id,
                    "AuctionDescription":auctionDetails?.auction_description,
                    "BidAmount":auctionDetails?.bid_amount,
                    "Type":"advanced"
                }
            })
        }

        setConfirmDialog({
            isOpen: true,
            title: isFinalOffer ? "Confirm Final Offer" : "Confirm Bid",
            message: isFinalOffer
                ? "Are you sure you want to submit this as your final offer?"
                : "Are you sure you want to submit this bid?",
            onConfirm: submitBidWithPayload,
            variant: isFinalOffer ? "warning" : "default",
        });
    };

    /**
     * Handles the action of exiting the auction with a confirmation prompt.
     */
    const handleExitAuction = () => {
        const exitAuction = () => {
         
        TrackMixPanel({
            Definition:"user has clicked on the back to summary button.",
            ModuleName:"tpmp auction",
            ScreenName:`auctions - ${auctionDetails?.auction_status} auctions - advance bidding screen`,
            Data:{
                "ProcurementName":auctionDetails?.procurement_name,
                "AuctionId":auctionDetails?.auction_id,
                "AuctionDescription":auctionDetails?.auction_description,
                "BidAmount":auctionDetails?.bid_amount,
                "Type":"advanced"
            }
        })

        //   updateTransporterStatusInDB(
        //     transporterInfo?.transporter_name,
        //     transporterInfo?.transporter_id,
        //     transporterInfo?.user_details?.user_id,
        //     location.state.auction_id,
        //     "exit",
        //     auctionClosed
        //   );

          getLiveTransporter(transporterInfo?.transporter_id,"exit");
          history.push({ pathname: "/auction" });
        };
      
        if (showBlocked) {
          exitAuction();
        } else {
          setConfirmDialog({
            isOpen: true,
            title: "Exit Auction?",
            message: "You will be redirected to the all auctions page.",
            onConfirm: exitAuction,
            variant: "default",
            disableButton:  false,
          });
        }
    };   
    
    useEffect(()=>{
        TrackMixPanel({
            Definition:"user has entered the advance auction bidding screen",
            ModuleName:"tpmp auction",
            ScreenName:`auctions - ${auctionDetails?.auction_status} auctions - advance bidding screen`,
        })
    },[auctionDetails])

    return (
        <>
        <Loader show={show} />
        <div className={classes['container']}>
            {/* <Loader show={show} /> */}
            <div id='internet-message' className={classes['internet-message']}>
                <div className={classes['cross-button']}>
                    <i style={{ color: '#393186', cursor: 'pointer' }} className='fa fa-times' onClick={e => document.getElementById('internet-message').style.display = 'none'}></i>
                </div>
                <br />
                <i style={{ color: 'orange', fontSize: 'xxx-large' }} className="fas fa-exclamation-triangle"></i>
                <br />
                <div className={classes['message']}>
                    <span><b>Your Internet connection is unstable. </b></span>
                    <span><b>Please check your connection and refresh / rejoin the auction for seamless bidding experience.</b></span>
                </div>
            </div>
            {showScroll ?
                <div style={{ marginBottom: '6%' }} id='scroll'>
                    <p className={classes["marquee"]}>
                        <span style={{fontSize: '20px'}}>{scroll}&nbsp;</span>
                    </p>
                </div>
            :null}
            {showBlocked?
                <div className={classes['main-block']}>
                    <div id={'blocked-popup'} className={classes['block']}>
                        <br/>
                        <h5><b>You are no longer allowed to bid for this lot.</b></h5>
                        <br/>
                        {/* <div className={classes['chat']}> */}
                        <PopupWidget
                          onClose={(e) => {
                            setShow(false);
                            Axios.put(`${Urls.auction}`, {
                               auction_id: auctionDetails.auction_id,
                               transporter_id: transporterInfo.transporter_id,
                               transporter_name: transporterInfo.transporter_name,
                               read_status: true,
                             })
                             .then((res) => {
                                    // setReceive(false)
                                    // setShowStatus(false)
                         })
                         .catch((err) => {
                           console.log(err);
                         });
                          }}
                          buttonLabel={
                            <>
                              Chat
                            </>
                          }
                        buttonclassName={`btn btn-sm ${classes['chatBtnBlocked']} py-2`}
                          modalTitle={auctionDetails.auction_description}
                          content={
                            <AuctionChat
                                fulldata = {auctionDetails}
                                auction_id={auctionDetails.auction_id}
                                transporter_id={transporterInfo.transporter_id}
                                transporter_name={
                                    transporterInfo.transporter_name
                                }
                                buttonClassName={setButtonClassName}
                                connection_msg={connection_msg_list} 
                                auctionClosedStatus={auctionClosed}
                            />
                          }
                          screen={`Truck Availability`}
                        />
                        {/* </div> */}
                        <button onClick={handleExitAuction} className={`${classes['exit-button1']} btn`}>Go Back to Auction Summary</button>
                    </div>
                </div>
            :null}
            {auctionpaused ? <div className={classes['main-block']}>
                <div id={'blocked-popup'} className={classes['block']}>
                    <br/>
                    <h5><b>This Auction is paused. Please wait until the further updates.</b></h5>
                    <div className={classes['paused_popup']}>
                    <div className={classes['chat']}>
                    <PopupWidget
                          onClose={(e) => {
                            setShow(false);
                            Axios.put(`${Urls.auction}`, {
                               auction_id: auctionDetails.auction_id,
                               transporter_id: transporterInfo.transporter_id,
                               transporter_name: transporterInfo.transporter_name,
                               read_status: true,
                             })
                             .then((res) => {
                                //  setShowStatus(false)
                                //  setReceive(false)
                         })
                         .catch((err) => {
                           console.log(err);
                         });
                          }}
                          buttonLabel={
                            <>
                              Chat
                            </>
                          }
                          buttonclassName={`btn btn-sm ${classes[buttonClassName]}`}
                          modalTitle={auctionDetails.auction_description}
                          content={
                            <AuctionChat
                                fulldata = {auctionDetails}
                                auction_id={auctionDetails.auction_id}
                                transporter_id={transporterInfo.transporter_id}
                                transporter_name={
                                    transporterInfo.transporter_name
                                }
                                buttonClassName={setButtonClassName}
                                connection_msg={connection_msg_list} 
                                auctionClosedStatus={auctionClosed}
                            />
                          }
                          screen={`Truck Availability`}
                        />
                    </div>
                    <div>
                    <button onClick={handleExitAuction} className={`${classes['exit-button0']} btn`}>Go Back to Auction Summary</button>
                </div>
                    </div>
                </div>
            </div>:null}

            <div className='row'>
                <div className='col-md-4'>
                    <h3 className={classes['header']}>{auctionDetails.auction_description}</h3>
                    {auctionDetails.zone ? 
                        <h5 style={{width:'100%', textAlign:'center', fontSize:"13px", fontWeight:'700', color:'#727271'}}>
                        Zone: {titleCase(auctionDetails.zone)}</h5>
                    : ''}
                </div>
                
                <div className='col-md-4'>
                    {auctionClosed ? ( <RemainingTime status="closed" />) : 
                    reload_timer ? (
                    <>
                        <RemainingTime
                            setStarttime={setStarttime}
                            paused_timestamp={paused_timestamp}
                            auction_paused={auctionpaused}
                            auctionDetails={auctionDetails}
                            setTimerKey={setTimerKey}
                            timerKey={timerKey}
                            screen="auction"
                            starttime={starttime}
                            date={TimerDate}
                            status={auctionDetails?.auction_status}
                            offset={offset}
                            id={location.state.auction_id}
                            setauctionClosed={setauctionClosed}
                            setAuctionpaused={setAuctionpaused}
                            setreload_timer={setreload_timer}
                            reload_timer={reload_timer}
                            setpaused_timestamp={setpaused_timestamp}
                            getAuctionDetails={getAdvanceAuctionDetails}
                            bucket={location?.state?.bucket}
                            setOffset={setOffset}
                        />
                    </>
                    ) : (
                    <RemainingTime
                        setStarttime={setStarttime}
                        paused_timestamp={paused_timestamp}
                        auction_paused={auctionpaused}
                        auctionDetails={auctionDetails}
                        screen="auction"
                        starttime={starttime}
                        setTimerKey={setTimerKey}
                        timerKey={timerKey}
                        date={TimerDate}
                        status={auctionDetails?.auction_status}
                        offset={offset}
                        id={location.state.auction_id}
                        setauctionClosed={setauctionClosed}
                        setAuctionpaused={setAuctionpaused}
                        setreload_timer={setreload_timer}
                        reload_timer={reload_timer}
                        setpaused_timestamp={setpaused_timestamp}
                        getAuctionDetails={getAdvanceAuctionDetails}
                        bucket={location?.state?.bucket}
                    />
                )}
                </div>

                <div className='col-md-3'>
                    <PopupWidget
                        onClose={(e) => {
                        setShow(false);
                            Axios.put(`${Urls.auction}`, {
                                auction_id: auctionDetails.auction_id,
                                transporter_id: transporterInfo.transporter_id,
                                transporter_name: transporterInfo.transporter_name,
                                read_status: true,
                            })
                            .then((res) => {})
                            .catch((err) => {
                            // setShow(false);
                                console.log(err);
                            });
                        }}
                        buttonLabel={
                        <>
                            Chat
                        </>
                        }
                        buttonclassName={`btn btn-sm ${classes[buttonClassName]}`}
                        modalTitle={auctionDetails.auction_description}
                        content={
                        <AuctionChat
                            fulldata = {auctionDetails}
                            auction_id={auctionDetails.auction_id}
                            transporter_id={transporterInfo.transporter_id}
                            transporter_name={
                                transporterInfo.transporter_name
                            }
                            buttonClassName={setButtonClassName}
                            connection_msg={connection_msg_list} 
                            auctionClosedStatus={auctionClosed}
                        />
                        }
                        disabled={auctionDetails.auction_status === 'closed'}
                        screen={`Truck Availability`}
                    />
                </div>
            </div>

            {auctionDetails && auctionDetails.type === 'advanced' ?
                <div className={classes['Auction-Container']}>
                    {!isMobile() ?
                    <>
                        <div style={{width: '100%', marginTop: '5px'}}>
                            <table className={classes['auction-table1']}>
                                <thead>
                                    <th style={{ width: '20%' }}>Auction ID</th>
                                    <th style={{ width: '20%' }}>My Bid</th>
                                    <th style={{ width: '20%' }}>L1 Quote</th>
                                    <th style={{ width: '20%' }}>My Rank</th>
                                    <th style={{ width: '20%' }}>My Last Bid Status</th>
                                </thead>
                                <tbody>
                                    {auctionDetails ? (<>
                                        <tr height='45'>
                                            <td style={{ textAlign: 'center', fontSize: '14px', width: '20%' }}>{auctionDetails.display_id ? auctionDetails.display_id : ''}</td>
                                            <td><input className={classes['Bid-Box4']} value={myBid ? numberWithCommas(myBid) : 'Not Quoted Yet'} /></td>
                                            <td><input className={classes['Bid-Box3']} value={L1_Quote ? numberWithCommas(L1_Quote) : '-'} /></td>
                                            {/* <td><input className={classes['Bid-Box3']} value={L1_Quote ? '-' : '-'} /></td> */}
                                            <td style={{ textAlign: 'center', fontSize: 'large' }}>
                                                {rank !== '' ?
                                                    rank === 1 ?
                                                        <>
                                                            <button className={classes['RankGreenButton']}>
                                                                <b>L {rank}</b>
                                                            </button>
                                                        </>
                                                        :
                                                        <>
                                                            {rank === 2 ?
                                                                <button className={classes['RankYellowButton']}>
                                                                    <b>L {rank}</b>
                                                                </button>
                                                                :
                                                                <button className={classes['RankRedButton']}>
                                                                    <b>L {rank}</b>
                                                                </button>
                                                            }
                                                        </>
                                                    : <span style={{fontSize: '14px'}}>Not Quoted Yet</span>
                                                }
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{Bid_updated === 'YES' ?
                                                <span style={{ color: 'green', paddingRight: '1%', fontSize: '15px', fontWeight: 'bolder' }}>Bid Accepted</span>
                                                :
                                                Bid_updated === 'NO' ?
                                                    <span style={{ color: 'red', paddingRight: '1%', fontSize: '15px', fontWeight: 'bolder' }} >Bid Rejected</span>
                                                    :
                                                    <span style={{ paddingRight: '1%', fontSize: '14px' }} >Not Quoted Yet</span>

                                            } </td>
                                        </tr>
                                    </>
                                    ) : (
                                        null
                                    )}

                                </tbody>
                            </table>
                        </div>
                        <br/>

                        <div style={{ width: '100%'}}> {/**maxHeight: '25vh', */}
                            <div>
                                <table className={classes['auction-table1']}>
                                    <thead> {/** width: '25%' */}
                                        <th style={{ textAlign: 'left', width: '25%', paddingLeft: '6px' }}>Lane Description</th>
                                        <th style={{ textAlign: 'left', width: '15%' }}>Lane Opening Price</th>
                                        <th style={{ textAlign: 'left', width: '13%' }}>Bid Decrement</th>
                                        <th style={{ textAlign: 'left', width: '10%' }}>Truck Loads</th>
                                        <th style={{ textAlign: 'left', width: '17%' }}>Bid Amount</th>
                                        <th style={{ textAlign: 'left', width: '16%' }}>Total Bid Spend</th>
                                        {auctionDetails?.final_offer === true ?
                                        <th style={{ textAlign: 'center', width: '10%' }}>Action</th> : null}
                                    </thead>
                                </table>
                            </div>
                            <div style={{maxHeight: '44vh', overflowY: 'auto'}}>
                                <table className={classes['auction-table1']}>
                                    <tbody>

                                        {optionList && optionList.length > 0 ?
                                            optionList.map((items, index) => {
                                                return <tr>
                                                    <td style={{textAlign: 'left', fontSize: '11px', padding: '5px', width: '20%'}}>{items.option_desc ? items.option_desc : 'NA'}</td>
                                                    <td style={{textAlign: 'center', width: '15%'}}><input className={classes['auction-op']} value={items.option_opening_bid ? numberWithCommas(parseInt(items.option_opening_bid * items.option_unit_metric)) : 'NA'}/></td>
                                                    <td style={{textAlign: 'center', width: '15%'}}><input className={classes['auction-bd']} value={items.option_bid_decrement ? numberWithCommas(items.option_bid_decrement) : 'NA'} /></td>
                                                    <td style={{textAlign: 'end', fontSize: '12px', paddingRight:'2%', width: '10%'}}>{items.option_unit_metric}</td>
                                                    <td className={classes['auction-ba']} style={{textAlign: 'center', fontSize: '12px', paddingRight:'1%', width: '20%'}}>
                                                        {auctionClosed ? (
                                                            <>
                                                                <button disabled onClick={e => BidDecrement(e, index)} className={classes['Increment-Button-Disabled']}>
                                                                    <i style={{ cursor: 'no-drop', color: 'white', backgroundColor: '#393186' }} className='fas fa-minus-square'></i>
                                                                </button>
                                                                <label className={classes['Bid-Amount']}>{items.option_bid_amount < 0 ? 0 : numberWithCommas(items.option_bid_amount)}</label>
                                                                <button disabled onClick={e => BidIncrement(e, index)} className={classes['Increment-Button-Disabled']}>
                                                                    <i style={{ cursor: 'no-drop', color: 'white', backgroundColor: '#393186' }} className='fas fa-plus-square'></i>
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <button disabled={items.option_bid_amount <= 0} onClick={e => BidDecrement(e, index)} className={classes['Increment-Button']}>
                                                                    <i style={{ cursor: 'pointer', color: 'white', backgroundColor: '#393186' }} className='fas fa-minus-square'></i>
                                                                </button>
                                                                <label className={classes['Bid-Amount']}>{items.option_bid_amount < 0 ? 0 : numberWithCommas(items.option_bid_amount)}</label>
                                                                <button onClick={e => BidIncrement(e, index)} className={classes['Increment-Button']}>
                                                                    <i style={{ cursor: 'pointer', color: 'white', backgroundColor: '#393186' }} className='fas fa-plus-square'></i>
                                                                </button>
                                                            </>
                                                        )}
                                                    </td>
                                                    <td className={classes['Bid-Amount1']}><input className={`${classes['auction-amount']}`} value={numberWithCommas(parseInt(items.option_bid_amount * items.option_unit_metric))}/></td>
                                                    {auctionDetails?.final_offer === true ?
                                                    <td className={classes['Bid-Amount1']}>            
                                                        <button
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => handleFinalOffer(index,auctionDetails)}
                                                            style={{ backgroundColor: "#393185", fontSize: "12px", marginLeft: "0%" }}
                                                            disabled={auctionClosed || auctionpaused || showBlocked}
                                                        >
                                                            Final Offer
                                                        </button>
                                                    </td> : null}
                                                </tr>
                                            })
                                        : null}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='row' style={{marginTop: '1%'}}>
                            <div className='col-md-4'>
                                <button onClick={handleExitAuction} className={`${classes['exit-button2']} btn`}>Go Back to Auction Summary</button>
                            </div>
                            <div className='col-md-3' style={{display:"flex",alignItems:"center",justifyContent:auctionDetails?.final_offer === true ? "space-between" : "center"}}>
                            {auctionDetails?.final_offer === true ?
                                <button 
                                    style={{backgroundColor: '#393185' }} 
                                    disabled={auctionClosed || auctionpaused || showBlocked} 
                                    onClick={() => submitHandler(true, null)} 
                                    className="btn btn-sm btn-primary"> All Final Offer
                                </button> 
                            : null}
                            <button 
                            // style={{marginLeft: '20%', marginTop: '3%'}} 
                            disabled={auctionClosed || auctionpaused || showBlocked} onClick={() => submitHandler(false)}
                                className="btn btn-sm btn-success">Submit Bid</button>
                            </div>
                            <div className='col-md-5' style={{paddingLeft: '12%'}}>
                                <span style={{color: 'black', fontSize: '14px'}}>Total Bid Amount:</span>     
                                <input data-tip data-for="amount" className={L1_Quote !== 0 && L1_Quote <= bidAmount ? classes['Large-Total-Amount'] : classes['Total-Amount']} value={numberWithCommas(bidAmount)} />
                                {
                                    bidlist.bid_amount <= bidAmount ? 
                                        <ReactTooltip id="amount" place="bottom" effect="float" backgroundColor='#393185!important'>
                                            <span>Bid Amount should be less than L1 quote</span>
                                        </ReactTooltip> : 
                                        null
                                }
                                <br/>
                                {isSubmitClicked && isBidInvalid ?  <span style={{color: 'red', fontStyle: 'italic', paddingLeft: '5%'}}>
                                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i> Bid Amount should be less than L1 Quote</span> 
                                : null}
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div style={{width: '100%', marginLeft: '5%'}}>
                            <table className={classes['auction-table']}>
                                <thead>
                                    <th style={{ width: '20%', fontSize: '12px' }}>Auction ID</th>
                                    <th style={{ width: '20%', fontSize: '12px' }}>My Bid</th>
                                    <th style={{ width: '20%', fontSize: '12px' }}>L1 Quote</th>
                                    <th style={{ width: '20%', fontSize: '12px' }}>My Rank</th>
                                    <th style={{ width: '20%', fontSize: '12px' }}>My Last Bid Status</th>
                                </thead>
                                <tbody>
                                    {auctionDetails ? (<>
                                        <tr height='60'>
                                            <td style={{ textAlign: 'center', fontSize: '12px', width: '20%' }}>{auctionDetails.display_id ? auctionDetails.display_id : ''}</td>
                                            <td><input className={classes['Bid-Box4']} value={myBid ? numberWithCommas(myBid) : 'Not Quoted Yet'} /></td>
                                            {/* <td><input className={classes['Bid-Box3']} value={L1_Quote ? '-' : '-'} /></td> */}
                                            <td><input className={classes['Bid-Box3']} value={L1_Quote ? numberWithCommas(L1_Quote) : '-'} /></td>
                                            <td style={{ textAlign: 'center', fontSize: '14px' }}>
                                                {rank !== '' ?
                                                    rank === 1 ?
                                                        <>
                                                            <button className={classes['RankGreenButton']}>
                                                                <b>L {rank}</b>
                                                            </button>
                                                        </>
                                                        :
                                                        <>
                                                            {rank === 2 ?
                                                                <button className={classes['RankYellowButton']}>
                                                                    <b>L {rank}</b>
                                                                </button>
                                                                :
                                                                <button className={classes['RankRedButton']}>
                                                                    <b>L {rank}</b>
                                                                </button>
                                                            }
                                                        </>
                                                    : <span style={{fontSize: '14px'}}>Not Quoted Yet</span>
                                                }
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{Bid_updated === 'YES' ?
                                                <span style={{ color: 'green', paddingRight: '1%', fontSize: '12px', fontWeight: 'bolder' }}>Bid Accepted</span>
                                                :
                                                Bid_updated === 'NO' ?
                                                    <span style={{ color: 'red', paddingRight: '1%', fontSize: '12px', fontWeight: 'bolder' }} >Bid Rejected</span>
                                                    :
                                                    <span style={{ paddingRight: '1%', fontSize: '12px' }} >Not Quoted Yet</span>

                                            } </td>
                                        </tr>
                                    </>
                                    ) : (
                                        null
                                    )}

                                </tbody>
                            </table>
                        </div><br />
                        <div style={{height: '34vh', overflowY: 'scroll', width: '100%', marginLeft: '5%'}}>
                            <table className={classes['auction-table']}>
                                <thead>
                                    <th style={{ width: '25%', textAlign: 'center', fontSize: '12px' }}>Items</th>
                                    <th style={{ width: '25%', textAlign: 'center', fontSize: '12px' }}>Opening Price</th>
                                    <th style={{ width: '25%', textAlign: 'center', fontSize: '12px' }}>Bid Decrement</th>
                                    <th style={{ width: '25%', textAlign: 'center', fontSize: '12px' }}>Bid Amount</th>
                                    <th style={{ textAlign: 'left', width: '15%' }}>Total Bid Spend</th>
                                    {auctionDetails?.final_offer === true ? 
                                    <th style={{ textAlign: 'center', width: '10%' }}>Action</th> : null}
                                </thead>
                                <tbody>
                                    {optionList && optionList.length > 0 ?
                                        optionList.map((items, index) => {
                                            return <tr>
                                                <td style={{textAlign: 'center', fontSize: '14px', padding: '1%', width: '25%'}}>{items.option_desc ? items.option_desc : 'NA'}</td>
                                                <td style={{textAlign: 'center', width: '20%'}}><input className={classes['auction-op']} value={items.option_opening_bid ? numberWithCommas(items.option_opening_bid) : 'NA'}/></td>
                                                <td style={{textAlign: 'center', width: '20%'}}><input className={classes['auction-bd']} value={items.option_bid_decrement ? numberWithCommas(items.option_bid_decrement) : 'NA'} /></td>
                                                <td style={{width: '35%'}} className={classes['auction-ba']} width='210'>
                                                    {auctionClosed ? (
                                                        <>
                                                            <button disabled onClick={e => BidDecrement(e, index)} className={classes['Increment-Button-Disabled']}>
                                                                <i style={{ cursor: 'no-drop', color: 'white', backgroundColor: '#393186' }} className='fas fa-minus-square'></i>
                                                            </button>
                                                            <label className={classes['Bid-Amount']}>{numberWithCommas(items.option_bid_amount)}</label>
                                                            <button disabled onClick={e => BidIncrement(e, index)} className={classes['Increment-Button-Disabled']}>
                                                                <i style={{ cursor: 'no-drop', color: 'white', backgroundColor: '#393186' }} className='fas fa-plus-square'></i>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button onClick={e => BidDecrement(e, index)} className={classes['Increment-Button']}>
                                                                <i style={{ cursor: 'pointer', color: 'white', backgroundColor: '#393186' }} className='fas fa-minus-square'></i>
                                                            </button>
                                                            <label className={classes['Bid-Amount']}>{numberWithCommas(items.option_bid_amount)}</label>
                                                            <button onClick={e => BidIncrement(e, index)} className={classes['Increment-Button']}>
                                                                <i style={{ cursor: 'pointer', color: 'white', backgroundColor: '#393186' }} className='fas fa-plus-square'></i>
                                                            </button>
                                                        </>
                                                    )}
                                                </td>
                                                <td className={classes['Bid-Amount1']}><input className={`${classes['auction-amount']}`} value={numberWithCommas(parseInt(items.option_bid_amount * items.option_unit_metric))}/></td>
                                                {auctionDetails?.final_offer === true ?
                                                <td className={classes['Bid-Amount1']}>            
                                                    <button
                                                        className="btn btn-sm btn-primary"
                                                        onClick={() => handleFinalOffer(index,auctionDetails)}
                                                        style={{ backgroundColor: "#393185", fontSize: "12px", marginLeft: "0%" }}
                                                        disabled={auctionClosed || auctionpaused || showBlocked}
                                                    >
                                                        Final Offer
                                                    </button>
                                                </td> : null}
                                            </tr>
                                        })
                                    : null}
                                    <tr>
                                        <td colSpan={3} style={{textAlign: 'right'}}>
                                            Total Amount : 
                                        </td>
                                        <td style={{textAlign: 'center'}}>
                                        <input className={L1_Quote > bidAmount ? classes['Total-Amount'] : classes['Total-Amount1']} value={numberWithCommas(bidAmount)} />
                                            </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <br/>
                        {isSubmitClicked && isBidInvalid ?  <span style={{color: 'red', fontStyle: 'italic', paddingLeft: '5%'}}>
                                <i className="fa fa-exclamation-circle" aria-hidden="true"></i> Bid Amount should be less than L1 Quote</span>  : null}
                        <center>
                            <button onClick={handleExitAuction} className={`${classes['exit-button2']} btn`}>Go Back to Auction Summary</button>
                            {auctionDetails?.final_offer === true ?
                            <button
                                style={{ marginLeft: '10%', backgroundColor: '#393185' }} 
                                disabled={auctionClosed || auctionpaused || showBlocked} 
                                onClick={() => submitHandler(true, null)} 
                                className="btn btn-sm btn-primary"> All Final Offer
                                {/* {allFinalOfferSent ? "All Final Offer Sent" : "All Final Offer"}  */}
                            </button> : null}
                            <button style={{marginRight: '22%'}} disabled={auctionClosed || auctionpaused || showBlocked} onClick={submitHandler} className="btn btn-sm btn-success">Submit</button>
                        </center>
                    </>
                    }
                </div>
                :              
                null
            }
        </div>

        <ConfirmDialog
            isOpen={confirmDialog.isOpen}
            onClose={resetConfirmDialog}
            onConfirm={confirmDialog.onConfirm}
            title={confirmDialog.title}
            message={confirmDialog.message}
            variant={confirmDialog.variant}
            disableButton={confirmDialog.disableButton}
        />
        </>
    )
}

export default AdvancedBiddingScreen
